import React, { useState, useEffect } from 'react';
import { ButtonColor, ButtonVariant, useModal } from '@ampol/design-system';

import 'features/cards/components/transaction-list/transaction-list.scss';
import Transactions from 'containers/transactions/transactions';
import TransactionsModalContent from 'components/transactions-modal-content/transactions-modal-content';
import { useCheckGetAllAccountsRequest } from 'components/use-get-all-accounts-request/use-get-all-accounts-request';
import { trackCustomEvent } from 'utilities/app-insights';
import { useSelector } from 'react-redux';


interface TransactionListProps { 
  accountId?, 
  cardNo?, 
  modalType?: 'card' | 'account'
  accountLevel?
}

/**
 * List of transactions and detail modal
 * @param accountId Default Filter by AccountID
 * @param cardNo Default Filter by CardNo
 */
const TransactionList = ({ 
  accountId, 
  cardNo, 
  modalType,
  accountLevel 
}: TransactionListProps) => {
  useCheckGetAllAccountsRequest();
  
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const loggedInUser = useSelector((state: any) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state: any) => state.userStore.assignedAccountNumber);

  useEffect(() => {
    if (selectedTransaction) {
      detailModal.open();
    }
  }, [selectedTransaction]);

  const handleTransactionModalClose = () => {
    setSelectedTransaction(null);
  };

  const detailModal = useModal({
    id: 'transaction-details',
    title: `${selectedTransaction?.id}`,
    subtitle: 'Transaction ID',
    content: <TransactionsModalContent item={selectedTransaction}/>,
    actions: [{
      label: 'Close',
      variant: ButtonVariant.Secondary,
      onClick: () => detailModal.close(),
    }],
    variant: 'triple',
    color: ButtonColor.Blue,
    onClose: handleTransactionModalClose
  });

  const handleItemSelected = (item) => {
    window.dataLayer.push({
      event: 'Card_Portal_Transactions_Individual_Select',
      button_click: true,
    });

    trackCustomEvent('View Transaction Details', loggedInUser, assignedAccountNumber, 'Clicked on Transaction row to view transaction details.', 
      { selectedAccount: item?.parentContractNumber, selectedCard: item?.cardNumber });
    setSelectedTransaction(item);
  };

  return <div className={'transaction-list'}>
    <Transactions
      onItemSelected={handleItemSelected}
      accountId={accountId}
      cardNo={cardNo}
      modalType={
        modalType ? modalType : 
          cardNo ? 'card' : 
            accountId ? 'account' : 
              null
      }
      accountLevel={accountLevel}
    />
  </div>;
};

export default TransactionList;
